import { MediaFile } from "./mediaFile.model";

export class Person {
  id: number;
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
  profile_picture: MediaFile;

  constructor() {
    this.id = -1;
    this.first_name = "";
    this.last_name = "";
    this.phone = "";
    this.email = "";
    this.profile_picture = new MediaFile();
  }
}
